import { Steps } from '@/models/steps';

export const assetsDir =
  process.env.NODE_ENV === 'production'
    ? 'wp-content/themes/belly-child/generator/assets'
    : './assets';

export const stepMods = {
  barista: [
    Steps.START,
    Steps.MOD,
    Steps.ROASTIN,
    Steps.PORTION,
    Steps.AMOUNT,
    Steps.LABEL,
    Steps.SUMMARY,
  ],
  debutant: [
    Steps.START,
    Steps.MOD,
    Steps.ROASTIN,
    Steps.FLAVOUR,
    Steps.AFTERTASTE,
    Steps.AROMA,
    Steps.ACIDITY,
    Steps.AMOUNT,
    Steps.LABEL,
    Steps.SUMMARY,
  ],
};

export const stepsContent: any = {
  [Steps.START]: {
    required: true,
    image: `${assetsDir}/SVG/start_bg.svg`,
    title: 'start.title',
    description: 'start.description',
  },
  [Steps.MOD]: {
    required: true,
    barista: {
      image: `${assetsDir}/mod-view-barista.png`,
      imageHover: `${assetsDir}/mod-view-barista-hover.png`,
      title: 'mod.barista.title',
      description: 'mod.barista.description',
      hover: false,
    },
    debutant: {
      image: `${assetsDir}/mod-view-debutant.png`,
      imageHover: `${assetsDir}/mod-view-debutant-hover.png`,
      title: 'mod.debutant.title',
      description: 'mod.debutant.description',
      hover: false,
    },
  },
  [Steps.ROASTIN]: {
    required: true,
    dunkel: {
      image: `${assetsDir}/mod-roastion-dunkel.png`,
      imageHover: `${assetsDir}/mod-roastion-dunkel-hover.png`,
      subtitle: 'roastin.dunkel.subtitle',
      title: 'roastin.dunkel.title',
      description: 'roastin.dunkel.description',
      hover: false,
    },
    hell: {
      image: `${assetsDir}/mod-roastion-hell.png`,
      imageHover: `${assetsDir}/mod-roastion-hell-hover.png`,
      subtitle: 'roastin.hell.subtitle',
      title: 'roastin.hell.title',
      description: 'roastin.hell.description',
      hover: false,
    },
  },
  [Steps.PORTION]: {
    required: true,
    image: `${assetsDir}/sour-view.png`,
    title: 'portion.title',
  },
  [Steps.ACIDITY]: {
    required: false,
    image: `${assetsDir}/sour-view.png`,
    title: 'acidity.title',
    description: 'acidity.description',
  },
  [Steps.AROMA]: {
    required: true,
    image: `${assetsDir}/aroma-view.png`,
    title: 'aroma.title',
    description: 'aroma.description',
  },
  [Steps.FLAVOUR]: {
    required: false,
    image: `${assetsDir}/aroma-view.png`,
    title: 'flavour.title',
    description: 'flavour.description',
  },
  [Steps.AFTERTASTE]: {
    required: false,
    image: `${assetsDir}/aroma-view.png`,
    title: 'aftertaste.title',
    description: 'aftertaste.description',
  },
  [Steps.AMOUNT]: {
    required: true,
    image: `${assetsDir}/amount-view.png`,
    title: 'amount.title',
    description: 'amount.description',
  },
  [Steps.LABEL]: {
    required: false,
    image: `${assetsDir}/label-view.png`,
    title: 'label.title',
    description: 'label.description',
  },
  [Steps.SUMMARY]: {
    required: false,
    title: 'summary.title',
    image: `${assetsDir}/sour-view.png`,
  },
};
